import { register, findAll, find } from '../../../Javascript/Utils.js'

// Play & Pause Hero-Video – inspired by
// https://robsimpson.digital/articles/autoplay-html5-video/

// Check if the users browser supports these features
const enhance = 'querySelector' in document && 'addEventListener' in window && 'classList' in document.documentElement

const Hero = el => {
  if (enhance) {
    document.documentElement.classList.add('heroVideo--enhanced')

    const componentPrefix = 'oHero-video'
    const videoFile = find(`.${componentPrefix}File`, el)
    const videoButtons = findAll(`.${componentPrefix}Button`, el)
    const videoPause = find(`.${componentPrefix}Button--pause`, el)
    const videoPlay = find(`.${componentPrefix}Button--play`, el)

    const pauseVideo = (video, play, pause) => {
      video.pause()
      // Set the pause button as pressed so it’s hidden and the play button is displayed instead
      play.setAttribute('aria-pressed', 'false')
      pause.setAttribute('aria-pressed', 'true')
      // Focus the play button so keyboard users can immediately play the video without having to tab away and back again
      play.focus()
    }

    const playVideo = (video, play, pause) => {
      video.play()
      // Set the play button as pressed so it’s hidden and the pause button is displayed instead
      play.setAttribute('aria-pressed', 'true')
      pause.setAttribute('aria-pressed', 'false')
      // Focus the pause button so keyboard users can immediately pause the video without having to tab away and back again
      pause.focus()
    }

    // check user settings „reduced motion“
    if (document.querySelector('html').getAttribute('data-reduced-motion')) {
      videoFile.removeAttribute('autoplay')
      pauseVideo(videoFile, videoPlay, videoPause)
    }

    videoButtons.forEach((videoButton, index) => {
      if (videoButton.classList.contains(componentPrefix + 'Button--pause')) {
        videoButton.addEventListener('click', () => {
          pauseVideo(videoFile, videoPlay, videoPause)
        })
      } else if (videoButton.classList.contains(componentPrefix + 'Button--play')) {
        videoButton.addEventListener('click', () => {
          playVideo(videoFile, videoPlay, videoPause)
        })
      }
    })
  }
}

register('Hero', Hero)
